<template>
<div class="bannerWrapper">
    <slot name="subMenuOf" class="subMenuOf"></slot>
    <div class="banner container text-center">
        <slot name="title"></slot>
    </div>
</div>
</template>

<script>
    export default {
    }
</script>

<style lang="scss" scoped>
    .bannerWrapper {
        .subMenuOf {
            color: #888;
            font-size: 24px;
            text-align: center;
        }

        .banner {
            position: relative;
            margin: 2vh auto 4vh auto;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 85%;
            height: 4.5rem;
            border: 1px solid #4d91da;
            text-align: center;
            color: #fff;
            background: #3987D8;
            border-radius: 4px;
            box-shadow: 0 0 30px rgba(0,0,0,.15) inset,
                        0 6px 10px rgba(0,0,0,.15);
            &:before,
            &:after {
                content: '';
                position: absolute;
                z-index: -1;
                left: -4rem;
                top: 24px;
                display: block;
                width: 8vw;
                height: 0px;
                border: 30px solid #3987D8;
                border-right: 20px solid #3987D8;
                border-bottom-color: #3987D8;
                border-left-color: transparent;
                transform: rotate(-5deg);
            }         

            &:after {
                left: auto;
                right: -4rem;
                border-left: 20px solid #3987D8;
                border-right: 30px solid transparent;
                transform: rotate(5deg);
            }
        }
    }
    @media (max-width: 992px) {
    /* rules here apply to devices from 0px to 992px (inclusive) */
        .banner {
            &:before {
                left: -3rem !important;
            }
            &:after {
                right: -3rem !important;
            }
        }
    }
    @media (max-width: 576px) {	
    /* rules here apply to devices from 0px to 576px (inclusive) */
        .banner {
            &:before {
                width: 12vw !important;
            }
            &:after {
                width: 12vw !important;
            }
        }

    }
</style>
